export default "__VITE_ASSET__fcrO$M25__"